import {TriDéf} from "../Tri.js";

export class TriColonneInfo extends HTMLElement {

    static nom = "tri-colonne-info";

    static Événements = Object.freeze({
        "changementTri": "TriColonneInfo-tri"
    });

    // static observedAttributes = ["colonneId"];
    colonneId;
    shadowRoot;

    constructor() {
        super();

        // https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_templates_and_slots
        let template = document.getElementById("triColonneInfo");
        let templateContent = template.content;
        this.shadowRoot = this.attachShadow({mode: "open"});
        this.shadowRoot.appendChild(templateContent.cloneNode(true));

        this.triCroissantÉlément = this.shadowRoot.getElementById("triCroissant");
        this.triDécroissantÉlément = this.shadowRoot.getElementById("triDécroissant");

        this.triCroissantÉlément.addEventListener("click", (e) =>
            this.envoieÉvénementTri(e, new TriDéf(this.colonneId, TriDéf.Ordre.CROISSANT, TriDéf.Source.UTILISATEUR)))
        this.triDécroissantÉlément.addEventListener("click", (e) =>
            this.envoieÉvénementTri(e, new TriDéf(this.colonneId, TriDéf.Ordre.DÉCROISSANT, TriDéf.Source.UTILISATEUR)))
    }

    masque() {
        this.shadowRoot.getElementById("tci").style.display = "none";
    }

    affiche(triDéf) {
        if (triDéf) {
            this.shadowRoot.getElementById("tci").style.display = "flex"
            if (triDéf.ordre === TriDéf.Ordre.CROISSANT) {
                this.triCroissantÉlément.classList.add("actif");
                this.triCroissantÉlément.innerText = "▲";

                this.triDécroissantÉlément.classList.remove("actif");
                this.triDécroissantÉlément.innerText = "▽";
            } else {
                this.triCroissantÉlément.classList.remove("actif");
                this.triCroissantÉlément.innerText = "△";

                this.triDécroissantÉlément.classList.add("actif");
                this.triDécroissantÉlément.innerText = "▼";
            }
        }

    }

    setPosition(position) {
        this.shadowRoot.querySelector("#triPosition span").innerHTML = position;
    }

    getColonneId() {
        return this.colonneId
    }

    envoieÉvénementTri(e, triDéf) {
        this.dispatchEvent(new CustomEvent(TriColonneInfo.Événements.changementTri, {
            detail: triDéf,
            bubbles: true,
            composed: true
        }))
    }

    connectedCallback() {
        this.colonneId = this.getAttribute("colonneId");
        // C'est ici que le DOM pourrait être construit si pas template
        // Idem pour style (inline ou link)
    }

    disconnectedCallback() {
        // console.log("Custom element removed from page.");
    }

    adoptedCallback() {
        // console.log("Custom element moved to new page.");
    }

    attributeChangedCallback(name, oldValue, newValue) {
    }

}
